import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";

export interface IRangeOfMotionGroupKeyPropertyEditable {
  rangeOfMotionGroupKey(): IPropertyEditable<string>;
}

export function instanceOfIRangeOfMotionGroupKeyPropertyEditable(instance: any): instance is IRangeOfMotionGroupKeyPropertyEditable {
  return instance
      && instance.rangeOfMotionGroupKey
      && instanceOfIPropertyEditable<string>(instance.rangeOfMotionGroupKey());
}
